import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.define-property";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
*/
import Immutable from 'immutable';
import * as actions from './actions';
import WFCmsRecord from '../../records/WFCmsRecord';
var cmsState = Immutable.fromJS({
  components: {},
  includeComponents: {},
  mojoComponents: {}
});

var wfCmsReducer = function wfCmsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cmsState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions.WF_CMS_REQUEST_START:
      return state.mergeDeep({
        components: action.cmsIds.reduce(function (components, cmsId) {
          var $component = state.getIn(['components', cmsId]);
          components[cmsId] = $component ? $component : WFCmsRecord({
            cmsId: cmsId,
            isFetching: true
          });
          return components;
        }, {})
      });

    case actions.WF_CMS_SET_DATA:
      {
        var keyArray = action.data.keySeq().toArray();
        return state.mergeDeep({
          components: keyArray.reduce(function (components, cmsId) {
            var $component = state.getIn(['components', cmsId]);

            if ($component) {
              components[cmsId] = $component.merge({
                data: action.data.getIn([cmsId, 'data'])
              });
            }

            return components;
          }, {})
        });
      }

    case actions.WF_CMS_SET_INDIVIDUAL_COMPONENT_DATA:
      {
        var _ref = action || {},
            cmsId = _ref.cmsId,
            data = _ref.data;

        var cmsData = data.getIn([cmsId, 'data']) || {};
        var isFetching = data.getIn([cmsId, 'isFetching']);
        return state.mergeDeep({
          components: _defineProperty({}, cmsId, WFCmsRecord({
            cmsId: cmsId,
            data: Immutable.Map(cmsData),
            isFetching: isFetching
          }))
        });
      }

    case actions.WF_CMS_SET_INCLUDE_COMPONENTS:
      {
        return state.mergeDeep({
          includeComponents: action.includeComponents
        });
      }

    case actions.WF_CMS_SET_MOJO_COMPONENTS:
      {
        return state.mergeDeep({
          mojoComponents: action.mojoComponents
        });
      }

    case actions.WF_CMS_REQUEST_END:
      {
        return state.mergeDeep({
          components: action.cmsIds.reduce(function (components, cmsId) {
            var $component = state.getIn(['components', cmsId]);

            if ($component) {
              components[cmsId] = $component.merge({
                isFetching: false
              });
            }

            return components;
          }, {})
        });
      }

    default:
      return state;
  }
};

export default wfCmsReducer;